import React from 'react'
import "./SubStyle.css"

const Soft_ERP = () => {
  return (
    <section className="OurServices">
     <h1 className="OurServices-title">Our ERP System</h1>
      <p className="OurServices-pera">Bring all your business operations together in one integrated platform. Our ERP System helps manage key functions including staffing, compliance, finance, reporting, and performance monitoring, providing real-time insights and improved operational efficiency.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Soft_ERP
